import { render } from "./cu-dialog.vue?vue&type=template&id=5818e4bc"
import script from "./cu-dialog.vue?vue&type=script&lang=js"
export * from "./cu-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__